(function () {
  "use strict";

  var STORAGE_KEY = "ohcrisp-vote-float-dismissed-until-v1";
  var isInstagramBrowser = /Instagram/i.test(window.navigator.userAgent || "");

  function getDismissStorage() {
    // Instagram's in-app browser keeps its own persistent localStorage. Using
    // sessionStorage there lets the reminder return the next time it is opened.
    return isInstagramBrowser ? window.sessionStorage : window.localStorage;
  }

  function readDismissedUntil() {
    try {
      return Number(getDismissStorage().getItem(STORAGE_KEY)) || 0;
    } catch (error) {
      return 0;
    }
  }

  function writeDismissedUntil(value) {
    try {
      getDismissStorage().setItem(STORAGE_KEY, String(value));
    } catch (error) {
      // The badge can still be dismissed for the current page view.
    }
  }

  function init(root) {
    if (!root || root.dataset.ohcvfReady) return;
    root.dataset.ohcvfReady = "true";

    var designMode = Boolean(window.Shopify && window.Shopify.designMode);
    if (!designMode && readDismissedUntil() > Date.now()) {
      root.hidden = true;
      return;
    }

    root.hidden = false;
    window.requestAnimationFrame(function () {
      root.classList.add("is-ready");
    });

    var close = root.querySelector("[data-ohc-vote-float-close]");
    if (!close) return;

    close.addEventListener("click", function () {
      var days = Math.max(1, Number(root.dataset.dismissDays) || 7);
      if (!designMode) {
        writeDismissedUntil(Date.now() + days * 24 * 60 * 60 * 1000);
      }
      root.classList.add("is-dismissed");
      window.setTimeout(function () {
        root.hidden = true;
      }, 250);
    });
  }

  function boot(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches("[data-ohc-vote-float]")) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll("[data-ohc-vote-float]")));
    }
    roots.forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
